import { Box, Typography, useMediaQuery, Button, Link, Paper } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import cs from 'classnames';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import MobileAppBar from '../../../components/MobileAppBar';
import useBasicStyles from '../../../layouts/BasicLayout/useBasicStyles';
import useCommonStyles from '../../../useCommonStyles';
import useHeaderStyles from '../../../utilities/useHeaderStyles';
import type { FormValues } from '../shared';

const SettingsHeader = () => {
    const { t } = useTranslation(['settingsPage', 'common']);
    const commonStyles = useCommonStyles();
    const basicStyles = useBasicStyles();
    const headerStyles = useHeaderStyles();
    const history = useHistory();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { dirty, isSubmitting } = useFormikContext<FormValues>();

    if (isSmall) {
        return (
            <MobileAppBar>
                <Box zIndex={1}>
                    <Link
                        className={commonStyles.primary2}
                        component="button"
                        onClick={history.goBack}
                        underline="none"
                    >
                        {t('common:portalBackButton')}
                    </Link>
                </Box>
                <Box display="flex" justifyContent="center" position="absolute" pr={2} width="100%">
                    <Typography className={commonStyles.fontWeightBold}>{t('settingsPage:title')}</Typography>
                </Box>
                <Box ml="auto" zIndex={1}>
                    <Link
                        className={commonStyles.primary2}
                        component="button"
                        disabled={!dirty || isSubmitting}
                        type="submit"
                        underline="none"
                    >
                        {t('common:save')}
                    </Link>
                </Box>
            </MobileAppBar>
        );
    }

    return (
        <>
            <Paper
                className={cs(basicStyles.backPaper, basicStyles.lightBoxShadow, basicStyles.stickyHeader)}
                elevation={0}
            >
                <Link className={cs(basicStyles.linkBack)} component="button" onClick={history.goBack}>
                    <ArrowBackIosIcon fontSize="small" /> {t('common:portalBackButton')}
                </Link>

                <Box className={basicStyles.rightToolbar} ml="auto">
                    <Box className={cs([commonStyles.buttonGroup])}>
                        <Button color="secondary" disabled={!dirty || isSubmitting} type="submit" variant="contained">
                            {t('common:save')}
                        </Button>
                    </Box>
                </Box>
            </Paper>
            <Box
                alignItems="center"
                className={cs([basicStyles.main, commonStyles.header, headerStyles.header])}
                display="flex"
            >
                <Typography className={commonStyles.title}>{t('settingsPage:title')}</Typography>
            </Box>
        </>
    );
};

export default SettingsHeader;
